import type { AppDispatch } from '@redux/store'

import useDispatch from '@hooks/useDispatch'

import * as taskListItemActions from '@redux/modules/taskListItem'
import * as campaignActions from '@redux/modules/campaign'
import * as artworkActions from '@redux/modules/artwork'

const deleteArtwork = (params: { deleteFn: () => Promise<unknown>, redirect?: string }) => {
  const { deleteFn, redirect } = params

  return deleteFn().then(() => {
    if (redirect){
      window.location.href = redirect
    }
  })
}

const fetchEditorOptions = (
  params: { dispatch: AppDispatch, redirect?: string, taskListItemId?: number, artworkId?: number },
) => {
  const {
    dispatch, redirect, taskListItemId, artworkId,
  } = params

  if (taskListItemId){
    const { artworkBuilderConfig: loadFn } = taskListItemActions

    return dispatch(loadFn(taskListItemId)).then((response) => {
      const { success } = response
      if (success){
        const { data } = response
        const mergedConfig = {
          ...data,
          redirectUrl: redirect,
        }

        return { success: true, data: mergedConfig }
      }

      const { errors } = response
      return { success: false, errors }
    })
  } if (artworkId){
    const { loadArtwork: loadArtworkFn } = artworkActions
    const { artworkBuilderConfig: loadFn } = campaignActions

    // Fetch Artwork
    // @ts-expect-error TS2769
    return dispatch(loadArtworkFn(artworkId)).then((artworkResult) => {
      if (!artworkResult.success || !artworkResult.data?.campaign_id) return artworkResult

      return dispatch(loadFn(artworkResult.data.campaign_id)).then((response) => {
        const { success } = response
        if (success){
          const { data } = response

          const mergedConfig = {
            ...data,
            redirectUrl: redirect,
          }

          return { success: true, data: mergedConfig }
        }

        const { errors } = response

        return { success: false, errors }
      })
    })
  }

  return Promise.resolve({ success: false, errors: ['Invalid parameters'] })
}

const goBack = (params: { redirect?: string }) => {
  const { redirect } = params

  if (redirect){
    window.location.href = redirect
  }
}

type UseArtworkBuilderOptions = {
  redirect?: string,
  taskListItemId?: number,
  artworkId?: number,
}

function useArtworkBuilder(options: UseArtworkBuilderOptions) {
  const {
    artworkId, redirect, taskListItemId,
  } = options

  const dispatch = useDispatch()

  return {
    callbacks: {
      deleteArtwork: (deleteFn: () => Promise<unknown>) => (
        deleteArtwork({ deleteFn, redirect })
      ),
      fetchEditorOptions: () => (
        fetchEditorOptions({
          dispatch, redirect, taskListItemId, artworkId,
        })
      ),
      goBack: () => goBack({ redirect }),
    },
  }
}

export default useArtworkBuilder
